<template>
	<div class="price-list-page">
		<!-- 顶部操作栏 -->
		<el-card class="action-card" shadow="hover">
			<div class="header-content">
				<h3 class="page-title">价格表管理</h3>
				<el-button type="primary" @click="handleCreate">
					<el-icon style="margin-right: 5px;"><Plus /></el-icon>
					新增价格表
				</el-button>
			</div>
		</el-card>

		<!-- 数据表格 -->
		<el-card class="table-card" shadow="never">
			<el-table 
				:data="priceList" 
				style="width: 100%" 
				v-loading="loading"
				border
				stripe
				:header-cell-style="{ background: '#f5f7fa', color: '#606266', fontWeight: 'bold' }"
			>
				<el-table-column prop="priceListName" label="价格表名称" min-width="200" show-overflow-tooltip />
				
				<el-table-column prop="creationTime" label="创建时间" width="180" align="center" sortable />
				
				<el-table-column label="操作" width="150" align="center" fixed="right">
					<template #default="scope">
						<el-button link type="primary" size="small" @click="handleView(scope.row)">
							查看详情
						</el-button>
						<el-button link type="primary" size="small" @click="handleEdit(scope.row)">
							编辑
						</el-button>
					</template>
				</el-table-column>
			</el-table>
			
			<el-empty v-if="!loading && priceList.length === 0" description="暂无价格表数据" />
		</el-card>
	</div>
</template>

<script>
	import { Plus } from '@element-plus/icons-vue';

	export default {
		components: { Plus },
		data() {
			return {
				loading: false,
				priceList: []
			}
		},
		methods: {
			// 新增
			handleCreate() {
				this.navigateToDetail('create', '');
			},
			
			// 查看
			handleView(row) {
				this.navigateToDetail('see', row.priceListId);
			},

			// 编辑
			handleEdit(row) {
				this.navigateToDetail('edit', row.priceListId);
			},

			// 路由跳转封装
			navigateToDetail(mode, id) {
				this.$router.push({
					path: "/finance/priceDetails",
					query: {
						mode: mode,
						priceListId: id
					}
				});
			},

			// 获取列表
			getPriceList() {
				this.loading = true;
				this.apiService.post({
						modules: "newPriceList",
						content: {}
					})
					.then((res) => {
						if (res.status) {
							this.priceList = res.data.priceList || [];
						} else {
							this.$message.error(res.msg || '获取数据失败');
						}
					})
					.catch(err => {
						console.error(err);
						this.$message.error('网络异常');
					})
					.finally(() => {
						this.loading = false;
					});
			}
		},
		mounted() {
			this.getPriceList();
		}
	}
</script>

<style scoped lang="scss">
	.price-list-page {
		padding: 20px;
		background-color: #f5f7fa;
		min-height: 100vh;
	}

	.action-card {
		margin-bottom: 20px;
		
		.header-content {
			display: flex;
			justify-content: space-between;
			align-items: center;
			
			.page-title {
				margin: 0;
				font-size: 18px;
				color: #303133;
				font-weight: 600;
			}
		}
	}

	.table-card {
		min-height: 400px;
	}
</style>